import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import OverheadCraneTable from './overhead-crane-table';
import OverheadCraneTile from './overhead-crane-tile';
import OverheadCraneSearch from './overhead-crane-search';
import OverheadCraneNavBar from './overhead-crane-nav-bar';

const OverheadCraneContent = props => {
  const [activeLane, setActiveLane] = useState('ALL');
  const tileView = useSelector(state => state.overheadCrane?.tileView ?? true);

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top w-100">
          <OverheadCraneSearch />
        </div>
        <div className="d-flex">
          <OverheadCraneNavBar onLaneChange={setActiveLane} activeLane={activeLane} />
          {!tileView ? <OverheadCraneTable activeLane={activeLane} /> : <OverheadCraneTile />}
        </div>
      </div>
    </div>
  );
};

export default OverheadCraneContent;
